<template>
  <edit-general-infos
    :id="entrepreneur._id"
  ></edit-general-infos>

  <hr>

  <edit-vat
    class="m-top-10"
    :id="entrepreneur._id"
  ></edit-vat>

  <hr>

  <edit-taxes
    class="m-top-10"
    :id="entrepreneur._id"
  ></edit-taxes>
  
  <span></span>
</template>

<script>
  import { computed, ref } from 'vue'
  import { useStore } from '@freebe/sdk/store'
  import router from '@core/router'
  import useConstantsWording from '@composables/use-constants'
  import { useDate, formatDate } from '@composables/use-date'
  import EditGeneralInfos from '@components/entrepreneurs/edition/edit-general-infos'
  import EditVat from '@components/entrepreneurs/edition/edit-vat'
  import EditTaxes from '@components/entrepreneurs/edition/edit-taxes'

  export default {
    setup () {
      const { get } = useStore('@freebe/entrepreneurs')

      const entrepreneurId = computed(() => 
        router.currentRoute.value.params.entrepreneur_id
      )
      const entrepreneur = computed(() => get(entrepreneurId.value))

      return {
        entrepreneur,
      }
    },

    components: {
      EditGeneralInfos,
      EditTaxes,
      EditVat,
    },
  }
</script>